<template>
    <div 
        class="m-tiles-row"
        :style="componentStyles"
    >
        <component
            :is="item.itemComponents"
            v-for="item in preparedItems"
            :key="item.id"
            :item="item"
            :brandsName="brandsName"
            :serviceTytle="serviceTytle"
            @click="handleClick"
        >
            <AFloorInfo
                v-if="item.floorInfo"
                :text="item.floorInfo"
            />
            <AAmountInfo
                v-else-if="item.amountCategories"
                :text="item.amountCategoriesText"
            />
            <span v-else/>
        </component>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import MTile from '../../molecules/m-tile';
import MTileOtg from '../../molecules/m-tile-otg';
import AFloorInfo from '../../atoms/a-floor-info';
import AAmountInfo from '../../atoms/a-amount-info';
import MBrandTile from '../../molecules/m-brand-tile';
import MTenantTile from '../../molecules/m-tenant-tile';
import MTileService from '../../molecules/m-tile-service';
import MCategoryTile from '../../molecules/m-category-tile';

export default {
    name: "MTilesRow",
    components: {
        MTile,
        MTileOtg,
        AFloorInfo,
        MBrandTile,
        AAmountInfo,
        MTenantTile,
        MTileService,
        MCategoryTile
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        tileType: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getBrandsRoot',
            'getPropsMapping',
            'getMapConfigProp',
            'getObjectFloorName',
            'getServiceCategories',
            'getTenantCategoriesRoot',
            'getServiceCategoriesRoot',
            'getObjectFloorNameWithTypeOfName'
        ]),
        preparedItems() {

            return this.items.map(el => {
                const tileItem = {...(el?.item || el)};

                tileItem.name = this.getTileName(tileItem);
                tileItem.amountCategories = this.getTileAmountCategories(tileItem);
                tileItem.floorInfo = this.getFloorInfo(tileItem)
                tileItem.isCategory  = this.isTileRootIdEqualRootObj(tileItem, this.getTenantCategoriesRoot);
                tileItem.isBrands = this.isTileRootIdEqualRootObj(tileItem, this.getBrandsRoot);
                tileItem.isService = this.isTileRootIdEqualRootObj(tileItem, this.getServiceCategoriesRoot);
                tileItem.isServiceItem = this.isServiceItem(tileItem);
                tileItem.amountCategoriesText = this.getTileAmountCategoriesText(tileItem);
                tileItem.files = this.getTileFiles(tileItem);
                tileItem.cssClass = this.getTileCssClass(tileItem);
                tileItem.couponText = this.couponTranslation;
                tileItem.isShowCouponLabel = this.isShowTileLabel(tileItem);
                tileItem.iconPlaceholder = this.iconPlaceholder;

                const tileItemType = this.getTileItemType(tileItem);
                tileItem.itemComponents = this.getTileItemComponent(tileItemType)

                return tileItem
            })
        },
        customFloorName() {
            return this.componentParams.custom_floor_name
        },
        shortFloorName() {
            return this.componentParams.short_floor_name
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.MTilesRow.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.MTilesRow.params`) || {};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.MTilesRow.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.MTilesRow.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        isUseCustomComponents() {
            return this.componentParams.is_use_custom_components;
        },
        tileItemComponents() {
            return this.componentParams.tile_item_component || {
                tenant: 'MTenantTile',
                category: 'MCategoryTile',
                brand: 'MBrandTile',
                service: 'MTileService'
            }
        },
        brandsName() {
            const translateName = this.componentParams.brands_name || 'ui.terminal.tiles.brands-title';
            return this.$t(translateName, 'Merkevarer')
        },
        serviceTytle() {
            const translateName = this.componentParams.service_title || 'ui.services-category';
            return this.$t(translateName, 'Service')
        },
        isShowConfigurableFloorName() {
            return this.componentParams.is_show_configurable_floor_name;
        },
        floorNameType() {
            return this.componentParams.floor_name_type
        },
        couponTranslation() {
            const translationName = this.componentParams.coupon_text || 'available_coupon_booklet'

            return this.$t(translationName, 'Finns i kuponghäfte')
        },
        couponCategory() {
            return this.componentParams.coupon_category || '';
        },
        iconPlaceholder() {
            return this.componentParams.icon_placeholder
        }
    },
    methods: {
        handleClick(item) {
            this.$emit('onClick', item);
        },
        getFloorInfo(item) {
            const props = this.getPropsMapping;

            if(this.floorNameType) {
                return this.getObjectFloorNameWithTypeOfName(item, this.floorNameType)
            }

            if(this.shortFloorName) {
                return item.meta[props.floor] || item.floor && item?.floor?.meta[props.name] +' '+item?.floor?.building_index
            }

            if(this.customFloorName && item?.floor?.meta[props.name]) {
                return _.capitalize(item?.floor?.meta[props.name])
            }

            if(this.isShowConfigurableFloorName) {
                return this.getObjectFloorName(item, false, false, false, true)
            }

            return  item.meta[props.floor] || item?.floor?.building_index ?
                _.capitalize(_.replace(item?.floor?.building_index, '_', ' ')) + ', ' +
                _.capitalize(item?.floor?.meta[props.name]) : '';
        },
        getTileItemType(item) {
            if(item?.type && item?.type == 'tenant') {
                return 'tenant'
            }
            if(item?.isBrands) {
                return 'brand'
            }
            if(item?.isCategory && !item?.isBrands) {
                return 'category'
            }
            if(item?.isService && !item?.isBrands) {
                return 'service'
            }
            return ''
        },
        getTileItemComponent(tileItemType) {
            if(
                this.componentParams.hasOwnProperty('is_use_custom_components') 
                && this.componentParams.is_use_custom_components
            ) {
                return this.tileItemComponents[tileItemType] || this.tileType
            }
            return this.tileType
        },
        getTileName(tile) {
            const props = this.getPropsMapping;

            return this.t(tile, props.name, '') || this.t(tile, 'name', '');
        },
        getTileAmountCategories(tile) {
            return tile?.objectsCount;
        },
        isTileRootIdEqualRootObj(tile, rootObj){
            if(!tile?.root_id) return false
            return tile?.root_id == rootObj?.id
        },
        getTileAmountCategoriesText(tile) {
            return tile.isBrands ?
                this.$t("ui.service.brands-count-sell", { count: tile.amountCategories }, tile.amountCategories)
                : tile.amountCategories && this.$t("ui.service.brands-count", { count: tile.amountCategories }, tile.amountCategories);
        },
        getTileFiles(tile) {
            return tile.isBrands
                ? { ...tile.files, icon: require('@/assets/images/icons/brands.svg') }
                : { ...tile.files };
        },
        getTileCssClass(tile) {
            return tile.isBrands ? 'tile-brands' : null;
        },
        isShowTileLabel(item) {
            return item?.lists?.categories?.includes(this.couponCategory)
        },
        isServiceItem(object) {
            let isServiceItem = false;
            const objectCategories = object?.lists?.categories;

            if(objectCategories && objectCategories?.length) {
                object?.lists?.categories.forEach(categoryId => {
                    const isServiceCategoriesIncludesObjectCategory = this.getServiceCategories.some(({id}) => id == categoryId);
                    if(isServiceCategoriesIncludesObjectCategory) {
                        isServiceItem = true
                    }
                })
            }
            return isServiceItem
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
